import React from 'react';
import {GradientBorder} from '../../component/util/StyledElements';
import styled from 'styled-components';
import {TscThemeNames, TscStyles} from '@techsmith/tsc-cloud-style-guide';
import cssConstants from '../../constants/cssConstants';
import withMemoizedContexts from '../../context/contextContainerHoC';
import {themeStore} from '../../context/themeProvider';

const HeaderContainerPlaceholder = styled.div`
   display: flex;
   flex-direction: column;
   width: 100%;
   flex: 0 0 auto;
   font-size: 0.875rem;
   top: 0;
   left: 0;
   right: 0;
`;

const StyledHeaderPlaceholder = styled.header<{theme: TscThemeNames}>`
   display: flex;
   flex-direction: row;
   background-color: ${cssConstants.headerBackgroundColor};
   color: ${TscStyles.color.text.light};
   height: ${cssConstants.headerHeight};
   padding: 0 1rem;
   justify-content: space-between;
   align-items: center;
   box-sizing: border-box;
`;

export const HeaderPlaceholderBase: React.FC<IStateMappedProps> = ({theme}) => (
   <HeaderContainerPlaceholder>
      <StyledHeaderPlaceholder theme={theme} />
      <GradientBorder />
   </HeaderContainerPlaceholder>
);

export interface IStateMappedProps {
   theme: TscThemeNames;
}

const mapStatesToProps = (
   // eslint-disable-next-line no-empty-pattern
   {},
   {theme}: Partial<IStateMappedProps>
): IStateMappedProps => ({theme});

export default withMemoizedContexts(mapStatesToProps, themeStore)(HeaderContainerPlaceholder);
